export default __webpack_public_path__ + "static/media/wallet-product-earn.a93d8b66.svg";